var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_417)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9375 55.625C39.42 55.625 39 55.205 39 54.6875V26.5625C39 26.045 39.42 25.625 39.9375 25.625C40.455 25.625 40.875 26.045 40.875 26.5625V54.6875C40.875 55.205 40.455 55.625 39.9375 55.625ZM75.6919 40.4956C75.4519 40.4956 75.2119 40.4037 75.0281 40.2219C71.6625 36.8525 67.1906 35 62.4375 35C57.6844 35 53.2125 36.8525 49.845 40.22C49.4794 40.5856 48.885 40.5856 48.5194 40.22C48.1537 39.8544 48.1537 39.26 48.5194 38.8944C56.1956 31.2181 68.6794 31.2181 76.3556 38.8944C76.7213 39.26 76.7213 39.8544 76.3556 40.22C76.1719 40.4038 75.9319 40.4956 75.6919 40.4956Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3788 43.8087C72.1388 43.8087 71.8988 43.7168 71.715 43.535C66.5981 38.4181 58.275 38.4181 53.16 43.535C52.7944 43.9006 52.2 43.9006 51.8344 43.535C51.4688 43.1693 51.4688 42.575 51.8344 42.2093C57.6825 36.3612 67.1925 36.3612 73.0425 42.2093C73.4081 42.575 73.4081 43.1693 73.0425 43.535C72.8588 43.7168 72.6188 43.8087 72.3788 43.8087Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0656 47.1219C68.8256 47.1219 68.5856 47.03 68.4019 46.8481C65.1131 43.5594 59.76 43.5594 56.4712 46.8481C56.1056 47.2138 55.5112 47.2138 55.1456 46.8481C54.78 46.4825 54.78 45.8881 55.1456 45.5225C59.1675 41.5044 65.7075 41.5044 69.7275 45.5225C70.0931 45.8881 70.0931 46.4825 69.7275 46.8481C69.5456 47.03 69.3056 47.1219 69.0656 47.1219Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7525 50.435C65.5125 50.435 65.2725 50.3431 65.0887 50.1612C63.6281 48.7006 61.2469 48.7006 59.7862 50.1612C59.4206 50.5269 58.8262 50.5269 58.4606 50.1612C58.095 49.7956 58.095 49.2012 58.4606 48.8356C60.6544 46.6419 64.2206 46.6419 66.4144 48.8356C66.78 49.2012 66.78 49.7956 66.4144 50.1612C66.2306 50.345 65.9925 50.435 65.7525 50.435Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4375 53.75C62.9553 53.75 63.375 53.3303 63.375 52.8125C63.375 52.2947 62.9553 51.875 62.4375 51.875C61.9197 51.875 61.5 52.2947 61.5 52.8125C61.5 53.3303 61.9197 53.75 62.4375 53.75Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 58.4375V56.5625C39 56.0469 39.4219 55.625 39.9375 55.625C40.4531 55.625 40.875 56.0469 40.875 56.5625V58.4375H42.75V56.5625C42.75 55.0119 41.4881 53.75 39.9375 53.75C38.3869 53.75 37.125 55.0119 37.125 56.5625V58.4375H39Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4375 76.25H30.5625C27.9769 76.25 25.875 74.1481 25.875 71.5625V62.1875C25.875 59.6019 27.9769 57.5 30.5625 57.5H33.375C33.8925 57.5 34.3125 57.92 34.3125 58.4375C34.3125 58.955 33.8925 59.375 33.375 59.375H30.5625C29.0119 59.375 27.75 60.6369 27.75 62.1875V71.5625C27.75 73.1131 29.0119 74.375 30.5625 74.375H77.4375C78.9881 74.375 80.25 73.1131 80.25 71.5625V62.1875C80.25 60.6369 78.9881 59.375 77.4375 59.375H38.0625C37.545 59.375 37.125 58.955 37.125 58.4375C37.125 57.92 37.545 57.5 38.0625 57.5H77.4375C80.0231 57.5 82.125 59.6019 82.125 62.1875V71.5625C82.125 74.1481 80.0231 76.25 77.4375 76.25Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5625 68.75C46.0803 68.75 46.5 68.3303 46.5 67.8125C46.5 67.2947 46.0803 66.875 45.5625 66.875C45.0447 66.875 44.625 67.2947 44.625 67.8125C44.625 68.3303 45.0447 68.75 45.5625 68.75Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1875 68.75C51.7053 68.75 52.125 68.3303 52.125 67.8125C52.125 67.2947 51.7053 66.875 51.1875 66.875C50.6697 66.875 50.25 67.2947 50.25 67.8125C50.25 68.3303 50.6697 68.75 51.1875 68.75Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8125 68.75C57.3303 68.75 57.75 68.3303 57.75 67.8125C57.75 67.2947 57.3303 66.875 56.8125 66.875C56.2947 66.875 55.875 67.2947 55.875 67.8125C55.875 68.3303 56.2947 68.75 56.8125 68.75Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4375 68.75C62.9553 68.75 63.375 68.3303 63.375 67.8125C63.375 67.2947 62.9553 66.875 62.4375 66.875C61.9197 66.875 61.5 67.2947 61.5 67.8125C61.5 68.3303 61.9197 68.75 62.4375 68.75Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0625 68.75C68.5803 68.75 69 68.3303 69 67.8125C69 67.2947 68.5803 66.875 68.0625 66.875C67.5447 66.875 67.125 67.2947 67.125 67.8125C67.125 68.3303 67.5447 68.75 68.0625 68.75Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6875 68.75C74.2053 68.75 74.625 68.3303 74.625 67.8125C74.625 67.2947 74.2053 66.875 73.6875 66.875C73.1697 66.875 72.75 67.2947 72.75 67.8125C72.75 68.3303 73.1697 68.75 73.6875 68.75Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5625 78.125C75.045 78.125 74.625 77.705 74.625 77.1875V75.3125C74.625 74.795 75.045 74.375 75.5625 74.375C76.08 74.375 76.5 74.795 76.5 75.3125V77.1875C76.5 77.705 76.08 78.125 75.5625 78.125ZM32.4375 78.125C31.92 78.125 31.5 77.705 31.5 77.1875V75.3125C31.5 74.795 31.92 74.375 32.4375 74.375C32.955 74.375 33.375 74.795 33.375 75.3125V77.1875C33.375 77.705 32.955 78.125 32.4375 78.125Z",
    fill: "#5f9098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9375 68.75H34.3125C33.795 68.75 33.375 68.33 33.375 67.8125C33.375 67.295 33.795 66.875 34.3125 66.875H39.9375C40.455 66.875 40.875 67.295 40.875 67.8125C40.875 68.33 40.455 68.75 39.9375 68.75Z",
    fill: "#5f9098"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_417",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_417",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(24 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpSystem);
export default __webpack_public_path__ + "static/media/ipSystem.9eb5d6c57f9a68706d4f35e7d6af5fca.svg";
export { ForwardRef as ReactComponent };